import * as apiFactory from "./ApiFactory";

import type { Mark } from "@/models/Mark";

export async function loadMarks(
  clientName: string,
  brand: string,
  caseReference: string,
  lensCode: string,
): Promise<Mark[]> {
  const client = await apiFactory.FeatuerWithBearer();
  return await client.getWithPollingSignal<Mark[]>(
    `api/mark/${clientName}/${brand}/${encodeURIComponent(caseReference)}?lensCode=${lensCode}`,
  );
}

export async function saveMark(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  mark: object,
) {
  const client = await apiFactory.WithBearer();
  return await client.post(["api/mark", clientName, brand, caseReference, fileReference], mark);
}

export async function deleteMark(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  markId: string,
) {
  const client = await apiFactory.WithBearer();
  return await client.delete(["api/mark", clientName, brand, caseReference, fileReference, markId]);
}

export async function rejectMarkTheme(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  markId: string,
  payload: { all: true } | { themes: string[] },
) {
  const client = await apiFactory.WithBearer();
  return await client.put(["api/mark", clientName, brand, caseReference, fileReference, markId], payload);
}

export async function redact(clientName: string, brand: string, caseReference: string, fileReference: string) {
  const client = await apiFactory.WithBearer();
  return await client.post(["api/recordaction/redact", clientName, brand, caseReference, fileReference]);
}
